import { Form, Input, Modal, Select, Button } from "antd";

const App = ({ isFilterModalOpen, setIsFilterModalOpen, handleFilter }) => {
  return (
    <>
      <Modal
        title="Filter Properties"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isFilterModalOpen}
        onCancel={() => setIsFilterModalOpen(false)}
        footer={false}
      >
        <Form
          layout="vertical"
          className="Crm-modal-container"
          onFinish={handleFilter}
        >
          <Form.Item
            name="referenceNumber"
            label="Reference Number"
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="saleOrRentprice"
            label="Price"
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="status"
            label="Status"
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Select
              options={[
                {
                  label: <span>Status</span>,
                  title: "Status",
                  options: [
                    { value: "", label: "Select" },
                    { value: "OFF_PLAN", label: "Off Plan" },
                    { value: "RENT", label: "Rent" },
                  ],
                },

                {
                  label: <span>Sales</span>,
                  title: "Sales",
                  options: [
                    { value: "SALE_OFF_PLAN", label: "Off-Plan" },
                    { value: "SALE", label: "Ready" },
                  ],
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="sortBy"
            label="Sort By Price "
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Select
              options={[
                {
                  value: "saleOrRentprice",
                  label: "From Lowest to highest",
                },
                {
                  value: "",
                  label: "From highest to Lowest",
                },
              ]}
              placeholder=""
            />
          </Form.Item>
          <Form.Item
            name="type"
            label="Property Type "
            rules={[{ required: false, message: "This field is required" }]}
          >
            <Select
              options={[
                { value: "", label: "Property Type" },
                { value: "Apartment", label: "Apartment" },
                { value: "Duplexes", label: "Duplexes" },
                { value: "Mansion", label: "Mansion" },
                { value: "PentHouse", label: "PentHouse" },
                { value: "Studio", label: "Studio" },
                { value: "Townhouse", label: "Townhouse" },
                { value: "Villa", label: "Villa" },
                { value: "bulk-rent-unit", label: "Bulk Rent Unit" },
                { value: "bulk-sale-unit", label: "Bulk Sale Unit" },
                { value: "business-center", label: "Business Center" },
                { value: "co-working-space", label: "Co Working Space" },
                { value: "factory", label: "Factory" },
                { value: "farm", label: "Farm" },
                { value: "full-floor", label: "Full Floor" },
                { value: "half-floor", label: "Half Floor" },
                { value: "labor-camp", label: "Labor Camp" },
                { value: "land", label: "Land" },
                { value: "office-space", label: "Office Space" },
                { value: "retail", label: "Retail" },
                { value: "shop", label: "Shop" },
                { value: "show-room", label: "Show Room" },
                { value: "staff-accommodation", label: "Staff Accommodation" },
                { value: "warehouse", label: "Warehouse" },
                { value: "whole-building", label: "Whole Building" },
              ]}
            />
          </Form.Item>
          {/* Footer Buttons */}
          <Form.Item>
            <div className="form_submit pt-15">
              <Button
                className="back_button"
                onClick={() => setIsFilterModalOpen(false)}
              >
                Cancel
              </Button>

              <Button htmlType="submit" type="primary">
                Find
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default App;
